<script> 
    import "leaflet";
    import "leaflet-routing-machine";
    import { onMount } from "svelte";
  
    let uid = Math.random().toString(36).substring(2);
    export let latlang; 
    export let icon = "pickup"; 
    latlang =latlang.split(";"); 

    let Flatlang =latlang[0].split(",");
    $: lat = Flatlang[1];
    $: lang = Flatlang[0]; 

    let Tlatlang =latlang[1].split(",");
    $: tolat = Tlatlang[1];
    $: tolang = Tlatlang[0];
  
    let L = window.L;
    let div = "map-"+uid;
  
    onMount(() => {
      loadMap();
    console.log(lat+"==>"+lang)

    });
  
    function loadMap() {
      document.getElementById("contmap-"+uid).innerHTML =
        "<div id='map-"+uid+"' style='width: 100%; height: 100%;'></div>";
      let map = L.map(div);
      if(icon=='pickup'){
      var aIcon = new L.Icon({
  iconUrl: 'https://api.geoapify.com/v1/icon/?type=material&color=%23198fd7&size=large&icon=store&textSize=small&apiKey=1b48259b810e48ddb151889f9ea58db0',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
      var bIcon = new L.Icon({
  iconUrl: 'https://api.geoapify.com/v1/icon/?type=material&color=%2319d78f&size=large&icon=user-alt&iconType=awesome&textSize=small&apiKey=1b48259b810e48ddb151889f9ea58db0',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
} else {
    
    var aIcon = new L.Icon({
  iconUrl: 'https://api.geoapify.com/v1/icon/?type=material&color=%23198fd7&size=large&icon=store&textSize=small&apiKey=1b48259b810e48ddb151889f9ea58db0',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var bIcon = new L.Icon({
  iconUrl: 'https://api.geoapify.com/v1/icon/?type=material&color=%2334d719&size=large&icon=motorcycle&iconType=awesome&textSize=small&apiKey=1b48259b810e48ddb151889f9ea58db0',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
}

      L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      id: "PositionPicker",
      noWrap: true,
    }).addTo(map);
  
      let routeControl = L.Routing.control({
        serviceUrl: "https://api.dekatan.com/warga/map",
        draggableWaypoints: false,
        collapsible: true,
        show: false,
        waypoints: [L.latLng(lat, lang), L.latLng(tolat, tolang)],
  createMarker: function(i, wp, nWps) {
    if (i === 0 ) {
      // here change the starting and ending icons
      return L.marker(wp.latLng, {
        icon: aIcon // here pass the custom marker icon instance
      });
    } else {
      // here change all the others
      return L.marker(wp.latLng, {
        icon: bIcon
      });
    }
  }
        
      }).addTo(map);
   
  
      routeControl.on("routesfound", function (e) {
        let routes = e.routes;
        let summary = routes[0].summary;
        // alert time and distance in km and minutes
        document.getElementById("summary-"+uid).innerHTML =
          "Jarak : " +
          Math.round(summary.totalDistance / 100) / 10 +
          " KM, diperkirakan selama : " +
          Math.round((summary.totalTime % 3600) / 60) +
          " Menit";
        
      });
    }
 
  </script> 
  <div class="relative" id="summary-{uid}" />
  <div class="relative w-full" id="contmap-{uid}" style="height: 90%;" />
  